// src/redux/job/jobReducer.js

import {
  JOB_ADD,
  JOB_UPDATE,
  JOB_DELETE,
  JOB_LIST,
  JOB_GET_BY_ID,
  JOB_LOADING,
  JOB_ERROR,
} from "./jobConstants";

const initialState = {
  jobList: [],
  jobDetails: {},
  isLoading: false,
  error: null,
};

export const jobReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOB_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case JOB_ADD:
      return {
        ...state,
        jobList: [...state.jobList, action.payload],
        isLoading: false,
      };

    case JOB_LIST:
      return {
        ...state,
        jobList: action.payload,
        isLoading: false,
      };

    case JOB_GET_BY_ID:
      return {
        ...state,
        jobDetails: action.payload,
        isLoading: false,
      };

    case JOB_UPDATE:
      return {
        ...state,
        jobList: state.jobList.map((job) =>
          job.id === action.payload.id ? action.payload : job
        ),
        isLoading: false,
      };

    case JOB_DELETE:
      return {
        ...state,
        jobList: state.jobList.filter((job) => job.id !== action.payload),
        isLoading: false,
      };

    case JOB_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};
